import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/modules/shared.module';

import { routing } from './user.routing';
import { AppComponent } from '../app.component';
import { ListComponent } from './list/list.component';

import { AuthGuard } from '../auth.guard';
import { UserService } from './services/user.service';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forRoot(routing, {}),
    SharedModule
  ],
  declarations: [ListComponent],
  exports: [],
  providers: [AppComponent, AuthGuard, UserService]
})
export class UserModule { }
